import { find, pipe, prop, propEq, values } from 'ramda';

export const getUserIdByEmail = (email, object) =>
  pipe(values, find(propEq('email', email)), prop('id'))(object);
